// extracted by mini-css-extract-plugin
export var section = "styles-module--section--LzPcK";
export var sectionFixed = "styles-module--sectionFixed--C1MEb";
export var parallaxBanner = "styles-module--parallaxBanner--wj+MK";
export var bubble = "styles-module--bubble--jdNVz";
export var bubble1 = "styles-module--bubble1--zqgKe";
export var bubble2 = "styles-module--bubble2--F3fIN";
export var bubble3 = "styles-module--bubble3--BWkTh";
export var bubble4 = "styles-module--bubble4--pd7AA";
export var bubble5 = "styles-module--bubble5--dqqxk";
export var bubbleCirclePink = "styles-module--bubbleCirclePink--FMNyt";
export var bubbleCircleBlack = "styles-module--bubbleCircleBlack--rmEM0";
export var bubblePink = "styles-module--bubblePink--6Oe8o";
export var bubbleBlack = "styles-module--bubbleBlack--6hh50";